import gql from 'graphql-tag';

export const UnlikeMutation = gql`
	mutation UnlikeMutation($contentId: ID!) {
		unlikeContent(input: { contentId: $contentId }) {
			content {
				id
				type
				likes {
					count
					currentUserLikes
				}
			}
		}
	}
`;
